/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  Form,
  FormField,
  FormControl,
  FormItem,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Textarea,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@repo/ui";
import {
  useCreateTicket,
  useSaveTicket,
  useGetTicketDetails,
  useSubmitTicket,
  useCreateCall,
  useSaveCall,
} from "services/tickets";
import sweetAlert from "components/sweet-alert";
import FormInput from "ui/Input";
import { PATHS } from "routes/paths";
import FormSelect from "ui/select";
import {
  useLookupAllAssignmentGroups,
  useLookupCustomers,
  useLookupMachinesServicePoints,
  useLookupGetRegion,
  useLookupAllRoute,
} from "services/lookups";
import { FormDropdown } from "ui/combo-box";
import Loader from "ui/page-loader";
import { Label } from "ui/label";
import { useGetCustomerDetails } from "services/customers";
import { useGetLocationDetails } from "services/service-points";
import CustomerDetails from "../common/customer-details";
import {
  emptyTicket,
  SERVICE_NATURE,
  SERVICE_STATUS,
  SERVICE_TYPES_PRIORITY,
} from "../constants";
import LocationDetails from "../common/location-details";
import TicketsByLocation from "../common/tickets-by-location";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { getLocalISODateString } from "utils/date-utils";

const emptyRequest = { ...emptyTicket, numberOfServicesImpact: 0 };
export default function CreateMissedDelayedTickets() {
  const [ticketDetails, setTicketDetails] = useState({ ...emptyRequest });
  const [allAssignmentGroups, setAllAssignmentGroups] = useState([]);
  const params = useParams();
  const navigate = useNavigate();
  const {
    mutate: getRegion,
    data: regionsListRes,
    isPending: gettingRegionsList,
  } = useLookupGetRegion();
  const {
    mutate: getRoutes,
    data: routeListRes,
    isPending: gettingRouteList,
  } = useLookupAllRoute();
  const {
    mutate: getCustomersList,
    data: customersListRes,
    isPending: gettingCustomersList,
  } = useLookupCustomers();
  const {
    mutate: getLocationsList,
    data: locationsListRes,
    isPending: gettingLocationsList,
  } = useLookupMachinesServicePoints();

  const {
    mutate: getAllAssignmentGroups,
    data: allAssignmentGroupRes,
    isPending: gettingAllAssignmentGroup,
    reset: resetAllAssignmentGroups,
  } = useLookupAllAssignmentGroups();

  const {
    mutate: createTicket,
    data: createTicketRes,
    isPending: creatingTicket,
    error: createTicketError,
    reset: resetCreateTicket,
  } = useCreateCall();

  const {
    mutate: saveTicket,
    data: saveTicketRes,
    isPending: savingTicket,
    error: saveTicketError,
    reset: resetSaveTicket,
  } = useSaveCall();

  const {
    mutate: submitTicket,
    data: submitTicketRes,
    isPending: submittingTicket,
    error: submitTicketError,
    reset: resetSubmitTicket,
  } = useSubmitTicket();

  const {
    mutate: getTicket,
    data: ticketDetailsRes,
    isPending: gettingTicket,
    reset: resetDetailsApi,
  } = useGetTicketDetails();

  const {
    mutate: getCustomerDetails,
    data: customerDetailsRes,
    isPending: gettingCustomerDetails,
    error: customerDetailsError,
    // reset: customerDetailsReset,
  } = useGetCustomerDetails();

  const {
    mutate: getAssetDetails,
    data: assetDetailsRes,
    error: assetDetailsError,
  } = useGetLocationDetails();

  const form = useForm({
    defaultValues: { ...emptyRequest },
    mode: "onSubmit",
  });
  useEffect(() => {
    getCustomersList();
    getAllAssignmentGroups();
    getRegion("UAE");
    getRoutes();
    if (params.ticketId) {
      getTicket(params.ticketId);
    }
  }, []);
  useEffect(() => {
    const region = form.getValues().region;
    if (region === "Northern Region") {
      form.setValue("assignmentGroup", `Cash Operations-Northern Emirates`);
    } else if (region === "Dubai") {
      form.setValue("assignmentGroup", `Cash Operations-Dubai`);
    } else if (region === "Abu Dhabi") {
      form.setValue("assignmentGroup", `Cash Operations-Abu Dhabi`);
    } else if (region === "Al Ain") {
      form.setValue("assignmentGroup", `Cash Operations-Al Ain`);
    }
  }, [form.watch("region")]);

  useEffect(() => {
    if (ticketDetailsRes && customersListRes) {
      if (ticketDetailsRes.status === 200) {
        const _details = {
          ...ticketDetailsRes.data,
          alertDateTime: ticketDetailsRes.data.alertDateTime
            ? new Date(ticketDetailsRes.data.alertDateTime)
            : null,
        };
        form.reset({ ...emptyRequest, region: _details.state, ..._details });
        getLocationsList(ticketDetailsRes.data.customerId);
        getCustomerDetails(_details.customerId);
        getAssetDetails(_details.assetId);
        setTicketDetails({ ..._details });
        resetDetailsApi();
      }
    }

    if (createTicketRes) {
      if (createTicketRes.status && createTicketRes.status === 200) {
        resetCreateTicket();
        navigate(PATHS.allServiceAndNonServiceCalls);
        form.reset();
      }
    }
    if (createTicketError) {
      resetCreateTicket();
    }
    if (saveTicketRes) {
      if (saveTicketRes.status && saveTicketRes.status === 200) {
        sweetAlert({
          title: "Operation Successful!",
          text: "Ticket Has Been Saved",
          icon: "success",
        });
        resetSaveTicket();
        navigate(PATHS.allServiceAndNonServiceCalls);
        form.reset();
      }
    }
    if (saveTicketError) {
      resetSaveTicket();
    }

    if (submitTicketRes) {
      if (submitTicketRes.status && submitTicketRes.status === 200) {
        resetSubmitTicket();
        navigate(PATHS.allServiceAndNonServiceCalls);
        form.reset({ ...emptyRequest });
      }
    }
    if (submitTicketError) {
      resetSubmitTicket();
    }

    if (allAssignmentGroupRes) {
      setAllAssignmentGroups(
        (allAssignmentGroupRes?.data || []).filter((elm) => {
          if (
            ![
              "Call Center",
              "Administrator",
              "Customer",
              "Cash Admin",
              "Planning & Analysis",
              "Security & Compliance",
              "CMC Operations-Dubai",
              "EK Outsource",
              "Fleet Management",
              "Business Development",
              "CMC Operations-Abu Dhabi",
              "TG Cash Customer Service",
            ].includes(elm.name)
          ) {
            return true;
          }
          return false;
        }),
      );
      resetAllAssignmentGroups();
    }
  }, [
    createTicketRes,
    createTicketError,
    saveTicketRes,
    saveTicketError,
    ticketDetailsRes,
    submitTicketError,
    submitTicketRes,
    allAssignmentGroupRes,
  ]);

  const generalProps = { errors: form.formState.errors, control: form.control };
  const verificationRules = {
    alertDateTime: { required: "Please Select Date & Time" },
    customerId: { required: "Please Enter Value" },
    numberOfServicesImpact: { required: "Please Enter Value" },
    category: { required: "Please Enter Value" },
    subCategory: { required: "Please Enter Value" },
    assignmentGroup: { required: "Please Enter Value" },
    routeId: { required: "Please Enter Value" },
    region: { required: "Please Enter Value" },
    reportedBy: { required: "Please Enter Value" },
    priority: { required: "Please Enter Value" },
    remarks: { required: "Please Enter Description" },
  };
  const createTicketPayload = () => {
    const _data = form.getValues();
    const payload = {
      alertDateTime: getLocalISODateString(_data.alertDateTime),
      customerId: _data.customerId,
      assetId: _data.assetId,
      assetLocationId: _data.locationId,
      assetLocationName: _data.locationName,
      routeId: _data.routeId,
      routeName: _data.routeName,
      region: _data.region,
      activityType: "Missed And Delayed Services",
      category: _data.category,
      subCategory: _data.subCategory,
      assignmentGroup: _data.assignmentGroup,
      numberOfServicesImpact: Number(_data.numberOfServicesImpact),
      creationChannel: "Web",
      reportedBy: _data.reportedBy,
      isChargeable: false,
      isCustomerComplaint: false,
      billingCharges: false,
      correlationId: "",
      priority: _data.priority
        ? SERVICE_TYPES_PRIORITY.filter((elm) => elm.id === _data.priority)[0]
            .value
        : "",
      remarks: _data.remarks,
      requesterContactNo: _data.requesterContactNo,
    };
    return payload;
  };
  const onSubmit = () => {
    const _data = form.getValues();
    const payload = {
      ticketId: _data.ticketId,
      ...createTicketPayload(),
    };
    submitTicket({ ...payload });
  };

  const onCancel = () => {};
  const onReset = () => {
    form.reset({ ...ticketDetails });
  };

  const onSave = () => {
    const payload = createTicketPayload();
    createTicket({ ...payload });
  };

  const onSaveAsDraft = () => {
    const payload = createTicketPayload();
    saveTicket({ ...payload });
  };
  const onCustomerChange = (data) => {
    form.setValue("assetId", "");
    form.setValue("locationName", "");
    form.setValue("region", "");
    form.setValue("assignmentGroup", "");
    form.setValue("assigneeId", "");
    getLocationsList(data);
    getCustomerDetails(data);
    form.setValue("activityType", "");
    form.setValue("category", "");
    form.setValue("subCategory", "");
    form.setValue("vaultAccessRequired", "No");
  };

  const onAssetChange = (data) => {
    getAssetDetails(data);

    const _asset = locationsListRes?.data.findIndex(
      (elm) => elm.servicePointId === data,
    );
    if (_asset !== -1) {
      if (form.watch("activityType")) {
        form.setValue("assignmentGroup", "");
      }

      form.setValue(
        "locationName",
        locationsListRes?.data[_asset].locationName,
      );
      form.setValue("locationId", locationsListRes?.data[_asset].locationId);
      form.setValue("region", locationsListRes?.data[_asset].state);
    } else {
      form.setValue("locationName", "");
      form.setValue("locationId", "");
      form.setValue("region", "");
    }
  };

  function AccountDetails() {
    if (customerDetailsError && customerDetailsError?.status === 403) {
      return <>User is not authorized to see Details</>;
    }
    if (!form.watch("customerId") || !customerDetailsRes) {
      return <>Select Account To Show Data</>;
    }

    return <CustomerDetails customer={customerDetailsRes.data} />;
  }

  function AssetDetails() {
    if (assetDetailsError && assetDetailsError?.status === 403) {
      return <>User is not authorized to see Details</>;
    }
    if (!form.watch("assetId") || !assetDetailsRes) {
      return <>Select Asset To Show Data</>;
    }

    return <LocationDetails location={assetDetailsRes.data} />;
  }
  function AccountRecords() {
    if (!form.watch("assetId")) {
      return <>Select Asset To Show Data</>;
    }

    return <TicketsByLocation servicePointId={form.watch("assetId")} />;
  }
  const onRouteChange = (routeId) => {
    const currentRoute = routeListRes?.data.find(
      (elm) => elm.routeId === routeId,
    );
    if (currentRoute) {
      form.setValue("routeName", currentRoute.routeNo || "");
    }
  };

  return (
    <>
      {gettingCustomersList ||
      gettingRegionsList ||
      savingTicket ||
      creatingTicket ||
      gettingRouteList ||
      gettingLocationsList ||
      gettingTicket ||
      submittingTicket ||
      gettingCustomerDetails ||
      gettingAllAssignmentGroup ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <Breadcrumb className="mt-5 text-black">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink>
                <Link to={PATHS.openTickets} className="text-black">
                  Tickets
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-black" />

            <BreadcrumbItem>
              <BreadcrumbPage className="text-black">
                Create Ticket
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <div className="flex flex-row justify-end w-full gap-2">
          {form.watch("status") !== "Draft" ? (
            <Button variant="secondary" onClick={form.handleSubmit(onSave)}>
              Save
            </Button>
          ) : (
            <Button variant="secondary" onClick={form.handleSubmit(onSubmit)}>
              Submit
            </Button>
          )}

          <Button
            variant="secondary"
            onClick={form.handleSubmit(onSaveAsDraft)}
          >
            Save As Draft
          </Button>
          <Button variant="secondary" onClick={onReset}>
            Reset
          </Button>

          <Link to={PATHS.openTickets}>
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
          </Link>
        </div>
        <Card className="form-card shadow-lg mx-0">
          <CardHeader>
            <CardTitle>Missed & Delayed Service</CardTitle>
          </CardHeader>
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(onSubmit)}
              className="space-y-8 custom-form-v2"
            >
              <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
                {/* <FormInput
                  {...generalProps}
                  isRequired={true}
                  name={"customerId"}
                  label={"Customer Id"}
                  rules={verificationRules.customerId}
                /> */}
                <div className="form-row-d-50">
                  <FormField
                    control={form.control}
                    name="alertDateTime"
                    rules={verificationRules.alertDateTime}
                    render={({ field }) => (
                      <FormItem>
                        <Label label="Alert Date & Time" isRequired />
                        <div className="form-date-picker">
                          <FormControl>
                            <DateTimePicker
                              variant="secondary"
                              className="px-3 py-2 border border-secondary rounded-md"
                              value={field.value}
                              placeholder="Select Date & Time"
                              onChange={(e) => {
                                field.onChange(e.target.value);
                              }}
                            />
                          </FormControl>
                          {form.formState.errors.alertDateTime ? (
                            <p className="text-destructive text-xs">
                              {form.formState.errors.alertDateTime.message}
                            </p>
                          ) : null}
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="form-row-d-50">
                  <FormDropdown
                    {...generalProps}
                    label="Account"
                    name="customerId"
                    isRequired
                    data={customersListRes?.data || []}
                    text="name"
                    id="customerId"
                    placeholder="Select Account"
                    rules={verificationRules.customerId}
                    onChange={onCustomerChange}
                    detailsView={AccountDetails()}
                  />
                  <FormInput
                    {...generalProps}
                    isRequired
                    name="reportedBy"
                    label="Requestor Name"
                    inputProps={{ autoFocus: true }}
                    rules={verificationRules.reportedBy}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Asset ID"
                    name="assetId"
                    placeholder="Select Asset"
                    // disabled={!form.watch("customerId")}
                    data={locationsListRes?.data || []}
                    text="locationId"
                    id="servicePointId"
                    onChange={onAssetChange}
                    detailsView={AssetDetails()}
                    recordsView={AccountRecords()}
                    recordContentClass="max-w-[1000px]"
                    info={
                      form.watch("customerId")
                        ? ""
                        : "Select Account To Load Data"
                    }
                  />
                  <FormInput
                    {...generalProps}
                    name="requesterContactNo"
                    label="Requestor Contact"
                  />
                  <FormInput
                    {...generalProps}
                    isRequired
                    name="locationName"
                    label="Location"
                    inputProps={{ readOnly: true }}
                  />
                  <FormDropdown
                    {...generalProps}
                    label="Assignment Group"
                    name="assignmentGroup"
                    isRequired
                    placeholder="Select Assignment Group"
                    data={allAssignmentGroups || []}
                    text="name"
                    id="name"
                    rules={verificationRules.assignmentGroup}
                  />
                  <FormDropdown
                    {...generalProps}
                    isRequired
                    name="routeId"
                    label="Route"
                    placeholder="Select Route"
                    data={
                      routeListRes?.data.map((elm) => ({
                        name: `${elm.routeNo}-${elm.description}`,
                        ...elm,
                      })) || []
                    }
                    id="routeId"
                    text="name"
                    rules={verificationRules.routeId}
                    onChange={onRouteChange}
                  />{" "}
                  <FormDropdown
                    {...generalProps}
                    isRequired
                    name="region"
                    label="Region"
                    placeholder="Select Region"
                    data={regionsListRes?.data || []}
                    id="name"
                    text="name"
                    rules={verificationRules.region}
                  />
                  <FormSelect
                    {...generalProps}
                    label="Nature of Service"
                    name="category"
                    isRequired
                    placeholder="Select Nature"
                    data={SERVICE_NATURE}
                    text="text"
                    id="id"
                    rules={verificationRules.category}
                  />
                  <FormSelect
                    {...generalProps}
                    isRequired
                    name="priority"
                    label="Service Type"
                    placeholder="Select Type"
                    data={SERVICE_TYPES_PRIORITY}
                    rules={verificationRules.priority}
                    id="id"
                    text="text"
                  />
                  <FormSelect
                    {...generalProps}
                    label="Service Status"
                    name="subCategory"
                    isRequired
                    placeholder="Select Service"
                    rules={verificationRules.subCategory}
                    data={SERVICE_STATUS}
                    text="text"
                    id="id"
                  />
                  <FormInput
                    {...generalProps}
                    isRequired
                    name="numberOfServicesImpact"
                    label="Number of Services Impact"
                    rules={verificationRules.numberOfServicesImpact}
                    inputProps={{ type: "number" }}
                    info="Numbers Only"
                  />
                </div>
                <div className="flex flex-col gap-inherit w-full mt-6">
                  <FormField
                    control={form.control}
                    name="remarks"
                    rules={verificationRules.remarks}
                    render={({ field }) => (
                      <FormItem>
                        <div className="flex flex-col gap-6 w-full">
                          <Label
                            label="Description"
                            isRequired
                            style={{
                              justifyContent: "flex-start",
                              textAlign: "left",
                            }}
                          />

                          <div>
                            <FormControl>
                              <Textarea
                                {...field}
                                className="min-w-full"
                                style={
                                  form.formState?.errors?.remarks
                                    ? {
                                        borderColor: "red",
                                      }
                                    : {}
                                }
                              />
                            </FormControl>
                            {form.formState?.errors &&
                            form.formState?.errors.remarks ? (
                              <p className="text-destructive text-xs">
                                {form.formState.errors.remarks.message}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </FormItem>
                    )}
                  />
                </div>
              </CardContent>
            </form>
          </Form>
        </Card>
      </div>
    </>
  );
}
